module.exports = __webpack_public_path__ + "img/pic_1_tc_new.3bf73940.png";